import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '../../../services/toast.service';
import { Widget } from '../../../types/Widget.type';
import { WidgetAdminService } from './widget-admin.service';

type Opcao<T> = { label: string, value: T };

@Component({
  selector: 'app-widgets',
  templateUrl: './widgets.component.html',
  styleUrl: './widgets.component.css'
})
export class WidgetsComponent implements OnInit {

  widgets: Widget[] = [];
  carregando = false;
  acessoNegado = false;

  filtroTexto = '';
  filtroModulo: string | null = null;
  filtroStatus: boolean | null = null;

  modulos: Opcao<string>[] = [];
  status: Opcao<boolean>[] = [
    { label: 'Ativo', value: true },
    { label: 'Inativo', value: false },
  ];

  constructor(
    private widgetAdminService: WidgetAdminService,
    private confirmationService: ConfirmationService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.carregar();
  }

  get widgetsFiltrados(): Widget[] {
    const texto = this.filtroTexto.trim().toLowerCase();

    return this.widgets.filter(w =>
      (!texto || w.nome.toLowerCase().includes(texto) || w.identificador.toLowerCase().includes(texto))
      && (!this.filtroModulo || w.moduloId === this.filtroModulo)
      && (this.filtroStatus === null || w.ativo === this.filtroStatus)
    );
  }

  carregar() {
    this.carregando = true;

    this.widgetAdminService.listar().subscribe({
      next: (data) => {
        this.widgets = data;
        this.modulos = this.opcoesDeModulo(data);
        this.carregando = false;
      },
      error: (error: HttpErrorResponse) => {
        this.carregando = false;
        this.tratarErro(error, 'Erro ao buscar os widgets');
      }
    });
  }

  excluir(widget: Widget) {
    this.widgetAdminService.emUso(widget.id!).subscribe({
      next: (quantidade) => {
        this.confirmationService.confirm({
          header: 'Excluir widget',
          message: quantidade > 0
            ? `Este widget será removido do dashboard de ${quantidade} usuário(s). Esta ação não pode ser desfeita.`
            : `Deseja excluir o widget "${widget.nome}"?`,
          icon: 'pi pi-exclamation-triangle',
          acceptIcon: 'none',
          rejectIcon: 'none',
          acceptLabel: 'Excluir',
          rejectLabel: 'Cancelar',
          acceptButtonStyleClass: 'p-button-danger',
          rejectButtonStyleClass: 'p-button-text',
          accept: () => this.confirmarExclusao(widget)
        });
      },
      error: (error: HttpErrorResponse) => this.tratarErro(error, 'Erro ao verificar o uso do widget')
    });
  }

  private confirmarExclusao(widget: Widget) {
    this.widgetAdminService.excluir(widget.id!).subscribe({
      next: () => {
        this.toastService.sucesso('Exclusão', 'Widget excluído com sucesso.');
        this.carregar();
      },
      error: (error: HttpErrorResponse) => this.tratarErro(error, 'Erro ao excluir o widget')
    });
  }

  private opcoesDeModulo(widgets: Widget[]): Opcao<string>[] {
    const modulos = new Map<string, string>();
    widgets.forEach(w => modulos.set(w.moduloId, w.moduloDescricao || w.moduloNome || w.moduloId));

    return [...modulos.entries()]
      .map(([value, label]) => ({ label, value }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  private tratarErro(error: HttpErrorResponse, mensagem: string) {
    if (error.status === 403) {
      this.acessoNegado = true;
      return;
    }

    if (error.status === 404) {
      this.toastService.erro('Erro', typeof error.error === 'string' ? error.error : 'Widget não encontrado');
      this.carregar();
      return;
    }

    this.toastService.erro('Erro', typeof error.error === 'string' && error.error ? error.error : mensagem);
    console.error(error);
  }
}
